import React from 'react';
import { SuggestibleRouteInterface } from '../_Global/Types/RouteTypes';
import MessageCentreThreadProvider from './Providers/MessageCentreThreadProvider';

const MessageCentre = React.lazy(() => import('./Pages/MessageCentre'));

const MessageCentreRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Message Centre',
		path: '/message-centre',
		element: (
			<React.Suspense fallback={<>...</>}>
				<MessageCentre />
			</React.Suspense>
		),
	},
	{
		title: 'Message Thread',
		path: '/message-centre/:messageId',
		element: (
			<React.Suspense fallback={<>...</>}>
				<MessageCentreThreadProvider>
					<MessageCentre />
				</MessageCentreThreadProvider>
			</React.Suspense>
		),
	},
];

export default MessageCentreRoutes;
